/**
 * Metabolic Quiz - Webhook Integration
 * Handles non-blocking webhook submission for quiz results
 */

(function() {
  'use strict';

  /**
   * Submit quiz data to webhook endpoint
   * @param {Object} data - Quiz result data
   * @returns {Promise} Promise resolving to webhook response
   */
  window.submitToWebhook = function(data) {
    // Get webhook URL from config
    const webhookUrl = window.quizConfig?.webhookUrl;

    // Skip if no webhook URL configured
    if (!webhookUrl || webhookUrl.trim() === '') {
      console.log('No webhook URL configured, skipping submission');
      return Promise.resolve({ skipped: true });
    }

    // Generate unique session ID
    const sessionId = generateSessionId();

    // Prepare payload
    const payload = {
      sessionId: sessionId,
      timestamp: new Date().toISOString(),
      email: data.email || null,
      profile: {
        primary: data.profile.primary,
        intensity: data.profile.intensity,
        scores: data.profile.scores,
        totalScore: data.profile.totalScore,
        urgencyLevel: data.profile.urgencyLevel,
        resultUrl: data.profile.resultUrl
      },
      responses: data.responses,
      duration: data.duration,
      metadata: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenSize: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        referrer: document.referrer || 'direct',
        url: window.location.href
      }
    };

    // Submit with timeout
    return Promise.race([
      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      }),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Webhook timeout')), 5000)
      )
    ])
    .then(response => {
      if (!response.ok) {
        throw new Error(`Webhook failed with status ${response.status}`);
      }
      console.log('Webhook submission successful');
      return response.json();
    })
    .catch(error => {
      console.warn('Webhook submission failed:', error.message);
      // Don't throw - webhook failure shouldn't block quiz
      return { error: error.message };
    });
  };

  /**
   * Generate unique session ID
   * @returns {string} UUID v4 string
   */
  function generateSessionId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /**
   * Test webhook endpoint
   * Call from console: testWebhook()
   */
  window.testWebhook = function() {
    const testData = {
      email: 'test@example.com',
      profile: {
        primary: 'hepatic',
        intensity: 'moderate',
        scores: { hepatic: 10, lymphatic: 5, lipid: 3 },
        totalScore: 18,
        urgencyLevel: 'moderate',
        resultUrl: '/pages/metabolic-quiz-result?profile=hepatic&intensity=moderate'
      },
      responses: [
        { questionId: 1, answerId: 'A', text: 'Test answer', weights: { hepatic: 2, lymphatic: 1, lipid: 0 } }
      ],
      duration: 45
    };

    console.log('Testing webhook with data:', testData);
    return window.submitToWebhook(testData)
      .then(result => {
        console.log('Webhook test result:', result);
        return result;
      });
  };

})();
